// Static, offline copy of the Cialda menu. The app makes no network calls —
// these two JSON files and the images in public/menu-images/ are the only
// source of menu data.
//
// Snapshot taken 2026-08-09 from the Click API (business 4):
//   menu.json     <- GET /api/menu-item/business/4
//   business.json <- GET /api/v1/business/data/4
// Every imageUrl was rewritten to /menu-images/<file>.
//
// To update the menu, edit src/data/menu.json and drop any new images into
// public/menu-images/.
import menu from './menu.json';
import business from './business.json';

export const localMenu = menu;
export const localBusiness = business;
